// Starts keeping unsaved planning work in the browser (draftStore) once the signed-in user is known, and shows
// anything put back from a crashed or closed tab.
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { config } from '@/config';
import { useMyPersonGuid } from '@/people/pictures';
import { startDraftStore } from './draftStore';

/** Whose work the store keeps: the Xpedition2 person, or one local user with sign-in off. */
export function useDraftStoreUser(): string | undefined {
  const personGuid = useMyPersonGuid();
  return config.authDisabled ? 'local' : personGuid;
}

export function useDraftStore() {
  const queryClient = useQueryClient();
  const user = useDraftStoreUser();
  useEffect(() => {
    if (!user) return;
    void startDraftStore(user).then((found) => {
      // A recovered Library route may already be showing as saved: show its changes instead.
      for (const { kind, guid } of found?.refs ?? [])
        void queryClient.invalidateQueries({ queryKey: ['trail', kind, guid] });
    });
  }, [user, queryClient]);
}
